/**
 * 线条元素手柄：仅渲染两端手柄，通过拖拽端点调整长度与角度。
 * 采用「透明热区 + 视觉小方块」双层结构，确保鼠标悬停光标切换稳定。
 */
import type { ReactNode } from 'react';
import { handleChromeWorldMetrics, selectionChromeWorldMetrics } from '../selectionChrome';
import { SelectionHandleVisual } from '../SelectionHandleVisual';
import type { HandlesProps } from './types';

export type LineHandlesProps = HandlesProps;

export function LineHandles({
  zoom,
  lineEndX,
  lineEndY,
  onStartLineHandle,
}: LineHandlesProps): ReactNode {
  const { hitSize, hitHalf } = handleChromeWorldMetrics(zoom);
  const { inset } = selectionChromeWorldMetrics(zoom);

  const startCx = inset - Math.min(0, lineEndX);
  const startCy = inset - Math.min(0, lineEndY);
  const endCx = inset + Math.max(0, lineEndX);
  const endCy = inset + Math.max(0, lineEndY);

  return (
    <>
      <div
        data-handle
        data-line-handle="start"
        data-handle-cursor="move"
        className="absolute pointer-events-auto flex items-center justify-center"
        style={{
          left: startCx - hitHalf,
          top: startCy - hitHalf,
          width: hitSize,
          height: hitSize,
          cursor: 'move',
        }}
        onMouseDown={(e) => onStartLineHandle('start', e)}
      >
        <SelectionHandleVisual zoom={zoom} className="pointer-events-none shrink-0" />
      </div>
      <div
        data-handle
        data-line-handle="end"
        data-handle-cursor="move"
        className="absolute pointer-events-auto flex items-center justify-center"
        style={{
          left: endCx - hitHalf,
          top: endCy - hitHalf,
          width: hitSize,
          height: hitSize,
          cursor: 'move',
        }}
        onMouseDown={(e) => onStartLineHandle('end', e)}
      >
        <SelectionHandleVisual zoom={zoom} className="pointer-events-none shrink-0" />
      </div>
    </>
  );
}
